export default "__VITE_ASSET__DC0rD8tt__"